<template lang="pug">
  label(:class="labelClass")
    input.switcher(type='checkbox' :value="value" :checked="value" @input="onChecked" :disabled="disabled")
    span.checkbox-label
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'cap-input-switchbox',
})
export default class CapInputSwitchbox extends Vue {
  @Prop({ default: false })
  value: boolean;

  @Prop({ default: false })
  disabled: boolean

  onChecked(val) {
    this.$emit('input', val.target.checked);
  }

  get labelClass() {
    return {
      disabled: this.disabled,
    };
  }
}
</script>

<style scoped lang="less">
label.disabled, label.disabled .checkbox-label {
  cursor: not-allowed !important;
}
label.disabled {
  opacity: 0.5;
  input[type=checkbox].switcher:checked + .checkbox-label:after,
  input[type=checkbox].switcher + .checkbox-label:after
  {
    background: #888888;
  }
}
input[type=checkbox].switcher:checked + .checkbox-label:after {
  left: 39px;
  transition: 0.15s;
  background: #80bd1c;
}

input[type=checkbox].switcher + .checkbox-label:after {
  content: '';
  top: 3px;
  left: 3px;
  right: auto;
  bottom: auto;
  display: block;
  position: absolute;
  height: 25px;
  width: 25px;
  background: #ffa93a;
  border-radius: 100%;
  transition: 0.15s;
}
</style>
